import { render, staticRenderFns } from "./TemplatePrimaryListing.vue?vue&type=template&id=1b95a0ae&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplatePrimaryListing.vue?vue&type=script&lang=js&"
export * from "./TemplatePrimaryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b95a0ae')) {
      api.createRecord('1b95a0ae', component.options)
    } else {
      api.reload('1b95a0ae', component.options)
    }
    module.hot.accept("./TemplatePrimaryListing.vue?vue&type=template&id=1b95a0ae&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('1b95a0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplatePrimaryListing.vue"
export default component.exports